let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("10YFK")).then(() => parcelRequire('f5h6d'));